const TECHNICAL_ERROR_MESSAGES = Object.freeze({
  BAD_REQUEST: '요청 내용을 확인해 주세요.',
  VALIDATION_ERROR: '요청 내용을 확인해 주세요.',
  UNSUPPORTED_MEDIA_TYPE: '지원하지 않는 요청 형식입니다.',
  PAYLOAD_TOO_LARGE: '요청 본문 크기가 너무 큽니다.',
  UNAUTHORIZED: '인증이 필요합니다. 다시 로그인해 주세요.',
  FORBIDDEN: '접근 권한이 없습니다.',
  ACCESS_DENIED: '접근 권한이 없습니다.',
  FORBIDDEN_SCOPE: '조회할 수 없는 조직 범위입니다.',
  NOT_FOUND: '대상을 찾을 수 없습니다.',
  CONFLICT: '현재 상태에서 처리할 수 없습니다.',
  SERVICE_UNAVAILABLE: '서비스를 일시적으로 사용할 수 없습니다.',
  INTERNAL_ERROR: '일시적인 오류가 발생했습니다.',
  ORG_NOT_FOUND: '조직을 찾을 수 없습니다.',
  USER_NOT_FOUND: '사용자를 찾을 수 없습니다.',
  REQUEST_NOT_FOUND: '의뢰를 찾을 수 없습니다.',
  INVITE_INVALID: '초대 링크가 올바르지 않습니다.',
  RATE_LIMIT_EXCEEDED: '요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.',
  SUBSCRIPTION_REQUIRED: '활성 구독이 필요합니다.',
  FEATURE_QUOTA_EXCEEDED: '이번 달 사용 가능 횟수를 모두 사용했습니다.',
  FEATURE_NOT_ENABLED: '현재 플랜에서 사용할 수 없는 기능입니다.',
  DATA_PROCESSING_CONSENT_REQUIRED: '개인정보 처리 동의가 필요합니다.',
  CONSENT_VERSION_MISMATCH: '동의 항목이 최신 버전이 아닙니다. 화면을 새로고침한 뒤 다시 시도해 주세요.',
  INVALID_CONSENT_VARIANT: '동의 항목 정보가 올바르지 않습니다.',
  INVALID_CONSENT_SERVICE: '동의 서비스 정보가 올바르지 않습니다.',
  CONSENT_REF_REQUIRED: '동의 기준 정보가 필요합니다.',
  CONSENT_ACTOR_REQUIRED: '동의 처리 사용자를 확인할 수 없습니다.',
  CUSTOMER_REF_REQUIRED: '고객 정보를 먼저 연결해 주세요.',
  CONSENT_JSON_ERROR: '동의 정보를 처리하지 못했습니다.',
  CONSENT_TEMPLATE_NOT_FOUND: '먼저 동의서 템플릿을 등록해 주세요.',
  CONSENT_LAYOUT_MISMATCH_PAGE_COUNT: '발행본 PDF 페이지 수가 템플릿과 일치하지 않습니다.',
  CONSENT_LAYOUT_MISMATCH_PAGE_SIZE: '발행본 PDF 페이지 크기가 템플릿과 일치하지 않습니다.',
  HEALTH_ANALYSIS_QUOTA_REQUIRED: '건강분석 사용 가능 횟수를 확인해 주세요.',
  ONLY_FAILED_CAN_RETRY: '실패 상태의 분석만 재시도할 수 있습니다.',
  IDENTITY_TTL_EXPIRED: '인증 정보가 만료되었습니다.',
  HEALTH_TWO_WAY_INFO_MISSING: '추가 인증 정보를 찾을 수 없습니다.',
  HEALTH_TWO_WAY_INPUT_REQUIRED: '추가 인증 입력값을 확인해 주세요.',
  HEALTH_TWO_WAY_INPUT_SAVE_FAILED: '추가 인증 입력 저장에 실패했습니다.',
  HEALTH_AUTH_TOKEN_EXPIRED: '인증 링크가 만료되었습니다.',
  HEALTH_IDENTITY_ALREADY_SUBMITTED: '이미 인증 정보가 제출되었습니다.',
  HEALTH_IDENTITY_REQUIRED: '주민등록번호를 입력해 주세요.',
  HEALTH_IDENTITY_INVALID_FORMAT: '주민등록번호는 13자리 숫자로 입력해 주세요.',
  HEALTH_AUTH_NOT_SMS: 'SMS 인증 방식이 아닙니다.',
  HEALTH_IDENTITY_NOT_SUBMITTED: '먼저 주민등록번호를 제출해 주세요.',
  HEALTH_SMS_ALREADY_SENT: '이미 SMS 인증번호가 발송되었습니다.',
  HEALTH_INVALID_AUTH_STATUS: '현재 상태에서는 처리할 수 없습니다.',
  HEALTH_SMS_SEND_FAILED: 'SMS 인증번호 발송에 실패했습니다.',
  HEALTH_SMS_AUTH_NO_REQUIRED: 'SMS 인증번호를 입력해 주세요.',
  HEALTH_SMS_AUTH_SAVE_FAILED: 'SMS 인증번호 저장에 실패했습니다.',
  RAW_EXPIRED: '보관된 원본 데이터가 만료되었습니다.',
  REANALYZE_FAILED: '리포트를 다시 분석하지 못했습니다.',
  GENERATION_FAILED: '상담 가이드를 생성하지 못했습니다.',
  COUNSELING_NOT_FOUND: '상담 가이드를 찾을 수 없습니다.',
  QUERY_REQUIRED: '검색어를 입력해 주세요.',
  INVALID_REQUEST: '요청 내용을 확인해 주세요.',
  HIRA_SERVICE_KEY_MISSING: '질병정보 검색을 일시적으로 사용할 수 없습니다.',
  HIRA_UPSTREAM_ERROR: '질병정보 외부 서비스 응답을 확인하지 못했습니다.',
  HIRA_PARSE_ERROR: '질병정보 외부 서비스 응답을 처리하지 못했습니다.',
  KCD_SEARCH_FAILED: 'KCD 검색 중 오류가 발생했습니다.',
  FILE_REQUIRED: '업로드할 파일이 필요합니다.',
  FILE_TOO_LARGE: '파일 용량이 너무 큽니다.',
  UNSUPPORTED_FILE_TYPE: '지원하지 않는 파일 형식입니다.',
  INVALID_FILE: '파일 내용을 확인해 주세요.',
  EMPTY_FILE: '파일에 반영할 데이터가 없습니다.',
  UPLOAD_FAILED: '파일 업로드에 실패했습니다.',
  IMPORT_FAILED: '데이터 가져오기에 실패했습니다.',
})

function isTechnicalErrorText(value) {
  const text = String(value || '').trim()
  return /^[A-Z][A-Z0-9_]*$/.test(text)
}

export function friendlyApiErrorMessageForCode(code) {
  const key = String(code || '').trim()
  if (!key || /^[0-9]+$/.test(key)) return ''
  return TECHNICAL_ERROR_MESSAGES[key] || ''
}

export function normalizeApiErrorMessage(message, code) {
  const text = String(message || '').trim()
  if (!text) return friendlyApiErrorMessageForCode(code)
  if (isTechnicalErrorText(text)) {
    return friendlyApiErrorMessageForCode(text) || friendlyApiErrorMessageForCode(code) || text
  }
  return text
}
